"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPostStatus = exports.PostStatus = void 0;
var PostStatus = exports.PostStatus = /*#__PURE__*/function (PostStatus) {
  PostStatus["Published"] = "published";
  PostStatus["Scheduled"] = "scheduled";
  PostStatus["Private"] = "private";
  PostStatus["Draft"] = "draft";
  PostStatus["Pitch"] = "pitch";
  PostStatus["Pending"] = "pending";
  return PostStatus;
}({});
var isPostStatus = candidate => {
  return Object.values(PostStatus).some(value => value === candidate);
};
exports.isPostStatus = isPostStatus;